import { createSingleton } from '@luna/utils';

import type { UseMutationOptions } from './createMutationTypes';

export const { get: getCreateMutationDefaultOptions, set: initCreateMutationDefaultOptions } =
    createSingleton<UseMutationOptions>();
